import axios from "axios";
import { UserHelper } from "../UserHelper";
import { VueRouter } from 'vue-router/types/router';
import { Store } from 'vuex'
import { VueCookies } from 'vue-cookies';

export default function setup(store: Store<any>, router: VueRouter, cookies: VueCookies): void {
    axios.interceptors.response.use(function (response) {
        return response
    }, function (error) {
        if (error.response.status === 401) {
            UserHelper.logoffSRC(store, router, cookies); 
        }
        return Promise.reject(error)
    })
} 